import axios from "axios";
import {
  biometricListUrl,
  biometricUnregisterUrl,
  bioregistrationOptions,
  bioregistrationUrl,
  login,
} from "./const";
import { host } from "../config";
import network from "./network";
import { BIOMETRIC_REGISTRATION_ENABLED } from "./types";





export const getRegistrationOptions = () => (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    const token = getState().auth.token;
    // you can now use the token
    network.post(bioregistrationOptions, {}, dispatch, getState)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};
export const registerBiometric = (params) => (dispatch,getState) => {
  return new Promise((resolve, reject) => {
  network.postJson(bioregistrationUrl, params, dispatch, getState).then((res) => {
    console.log(res)
    resolve(res.data)
    })
    .catch((err) => {
      console.log(err)
      reject(err)
  });;
  });
};

export const getLoginOptions = (email) => async () => {
  return new Promise((resolve,reject)=>{
    axios.post(host+'/webauthn/login/options', { email }).then((res) => {
      if (res.status === 200) {
        resolve(res.data);
      } 
    }
    ).catch((err) => {
      console.error('Error fetching login options:', err);
      reject(err);
    });
  })
};

export const verifyLogin = (data) => async () => {
  const res = await axios.post(host+'/webauthn/login', data);
  return res.data;
};
export const getUserRegistrationCount = () => (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    const token = getState().auth.token;
    // you can now use the token
    network.post(biometricListUrl, {}, dispatch, getState)
      .then((res) => {
        resolve(res.data)
         dispatch({
          type: BIOMETRIC_REGISTRATION_ENABLED,
          payload: res.data,
        });
        
      }
    )
      .catch((err) => reject(err));
  });
};
export const unregisterBiometric = () => (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    const token = getState().auth.token;
    // you can now use the token
    network.post(biometricUnregisterUrl, {}, dispatch, getState)
      .then((res) => {
        resolve(res.data)
        dispatch({
          type: BIOMETRIC_REGISTRATION_ENABLED,
          payload: false,
        });
        
      }
    )
      .catch((err) => reject(err));
  });
};